import React from 'react';
import { mockData } from './data';
import { TrendingUpIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function MonthlyProgress() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay: 0.1
  }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col" data-id="element-238">
      <div className="bg-[#0A1F5C] text-white px-4 py-2.5 flex justify-between items-center" data-id="element-239">
        <div className="flex items-center gap-2 font-semibold text-sm tracking-wide" data-id="element-240">
          <TrendingUpIcon className="w-4 h-4" data-id="element-241" />
          MONTHLY PROGRESS
        </div>
        <div className="text-xs font-medium text-blue-100" data-id="element-242">
          May 1 – May 31, 2025
        </div>
      </div>

      <div className="p-6 flex-1 flex flex-col justify-center" data-id="element-243">
        <div className="flex flex-col md:flex-row gap-6 md:gap-8 md:items-start" data-id="element-244">
          <div className="flex-1 text-center md:text-left" data-id="element-245">
            <span className="text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider mb-2 block" data-id="element-246">
              Total Points (Month to Date)
            </span>
            <div className="flex items-baseline justify-center md:justify-start gap-2" data-id="element-247">
              <span className="text-6xl md:text-7xl font-bold text-[#0A1F5C] tabular-nums tracking-tight leading-none" data-id="element-248">
                {mockData.monthly.points}
              </span>
              <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-249">
                Points
              </span>
            </div>
          </div>

          <div className="w-full md:w-60 md:border-l md:border-gray-100 md:pl-6" data-id="element-250">
            <div className="flex justify-between items-baseline border-b border-gray-100 pb-2 mb-2" data-id="element-251">
              <span className="text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider" data-id="element-252">
                Monthly Goal
              </span>
              <span className="text-sm font-bold text-[#0A1F5C] tabular-nums" data-id="element-253">
                {mockData.monthly.goal}
                <span className="text-[10px] text-gray-500 ml-1" data-id="element-254">PTS</span>
              </span>
            </div>
            <div className="flex justify-between items-baseline border-b border-gray-100 pb-2 mb-2" data-id="element-255">
              <span className="text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider" data-id="element-256">
                Remaining
              </span>
              <span className="text-sm font-bold text-[#0A1F5C] tabular-nums" data-id="element-257">
                {mockData.monthly.remaining}
                <span className="text-[10px] text-gray-500 ml-1" data-id="element-258">PTS</span>
              </span>
            </div>
            <div className="flex justify-between items-baseline" data-id="element-259">
              <span className="text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider" data-id="element-260">
                % Of Goal
              </span>
              <span className="text-lg font-bold text-[#16A34A] tabular-nums" data-id="element-261">
                {mockData.monthly.percentComplete.toFixed(1)}%
              </span>
            </div>
          </div>
        </div>

        <div className="mt-6" data-id="element-262">
          <div className="flex justify-between text-[10px] font-bold text-[#0A1F5C] uppercase tracking-wider mb-2" data-id="element-263">
            <span data-id="element-264">Progress to Goal</span>
            <span className="text-[#16A34A]" data-id="element-265">
              {mockData.monthly.percentComplete.toFixed(1)}%
            </span>
          </div>
          <div className="h-3 w-full bg-gray-100 rounded-full overflow-hidden" role="progressbar" aria-valuenow={mockData.monthly.percentComplete} aria-valuemin={0} aria-valuemax={100} data-id="element-266">
            <motion.div initial={{
            width: 0
          }} animate={{
            width: `${mockData.monthly.percentComplete}%`
          }} transition={{
            duration: 1,
            delay: 0.5,
            ease: 'easeOut'
          }} className="h-full bg-[#16A34A] rounded-full" data-id="element-267" />
          </div>
          <p className="text-[11px] text-gray-500 mt-2 font-medium text-right" data-id="element-268">
            On pace: projected ~{mockData.monthly.projected} by month end
          </p>
        </div>
      </div>
    </motion.section>;
}